/* eslint-disable tailwindcss/no-custom-classname */

import { FC, Fragment, memo, useEffect, useState } from "react";

interface Props {
  listStep: string[];
  activeStep: number;
  onChangeStep?: (idx: number) => void;
  onClick?: () => void | Promise<void>;
  containerClassName?: string;
}

const StepBase: FC<Props> = ({
  listStep,
  activeStep,
  onChangeStep,
  containerClassName = "",
}) => {
  const [active, setActive] = useState<number>(activeStep);
  useEffect(() => {
    setActive(activeStep);
  }, [activeStep]);

  const activeStepClass = (idx: number) => {
    if (active === idx) {
      return "text-white bg-[#41C9B4] !border-[#41C9B4]";
    }
    if (active > idx) {
      return "text-white bg-[#A3A8AC] !border-[#A3A8AC]";
    }
    return "text-[#A3A8AC] border-[#DBE0E4]";
  };
  const activeTextClass = (idx: number) => {
    const baseClass = "text-xs text-center font-bold ";
    if (active === idx) {
      return baseClass + "text-[#41C9B4]";
    }
    return baseClass + "text-[#A3A8AC]";
  };
  const handleStepChange = (idx: number) => {
    if (onChangeStep) {
      return idx; // Todo update change step in future
      // setActive(idx);
      // onChangeStep(idx);
    }
  };

  return (
    <div>
      <div
        className={`flex w-full bg-white border-b border-gray-100 mx-auto gap-2 md:gap-3 pr-4 fixed top-0 left-0 right-0 justify-center items-center h-[80px] md:h-[88px] z-[50] ${containerClassName}`}
      >
        {listStep.map((item, idx) => (
          <Fragment key={idx}>
            <div className="flex items-center md:items-center gap-x-2 md:gap-x-3 w-full md:h-10 max-w-[202px]">
              {idx !== 0 ? (
                <div className="w-[10px] overflow-hidden inline-block">
                  <div className="h-3 md:h-4 bg-[#A3A8AC] rotate-45 origin-top-left"></div>
                </div>
              ) : (
                <div className="w-4 overflow-hidden inline-block">
                  <div className="h-2 md:h-5"></div>
                </div>
              )}
              <div className="flex flex-col items-center w-full">
                <button
                  onClick={() => handleStepChange(idx)}
                  key={idx}
                  className={`${activeStepClass(
                    idx,
                  )} px-0 border-2 text-sm md:text-base font-bold rounded-[30px] text-center w-8 h-8 md:h-10 md:w-full cursor-auto`}
                >
                  <span className="hidden md:inline">
                    {idx < 9 ? `0${idx + 1}` : idx} {item}
                  </span>
                  <span className="inline md:hidden">
                    {idx + 1 < 10 ? `0${String(idx + 1)}` : idx}
                  </span>
                </button>
              </div>
            </div>
          </Fragment>
        ))}
      </div>
      <div
        className={`flex w-full mx-auto bg-white gap-x-1 pr-4 pb-4 md:hidden mt-2 border-b border-[#EFEFEF] fixed top-[59px] left-0 right-0 z-50 ${containerClassName}`}
      >
        {listStep.map((item, idx) => (
          <Fragment key={idx}>
            <div className="flex items-center md:items-center gap-x-1 w-full md:h-10">
              {idx !== 0 ? (
                <div className="w-[10px] overflow-hidden inline-block">
                  <div className="h-2 md:h-5"></div>
                </div>
              ) : (
                <div className="w-4 overflow-hidden inline-block">
                  <div className="w-2 md:h-5"></div>
                </div>
              )}
              <div className="flex flex-col items-center w-full">
                <span className={activeTextClass(idx)}>{item}</span>
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export const Step = memo(StepBase);
